import { getBasePath } from '@pressreader/routing';

export const MODULE_NAME = '@pressreader/views-common';

export const TRANSLATE_CONTEXT_MENU_NAME = 'contextmenu.views.common.translate';

export const interfaceLanguageContextMenuName = 'contextmenu.views.common.interfacelang';
export const fontsContextMenuName = 'contextmenu.views.common.fonts';
export const fontTypeContextMenuName = 'contextmenu.views.common.fonttype';

export const localSettingsCurrentScaleName = 'TextView.Scale';
export const localSettingsCurrentFontsetName = 'TextView.Fontset';
export const localSettingsCurrentLineSpacingName = 'TextView.LineSpacing';

export const COOKIE_MULTILANGUAGE_KEY = `${getBasePath()}multilanguage`;

export const MAX_FONT_SCALE = 7;
export const MIN_FONT_SCALE = 1;

export const FEATURE_FLAG_HOMEFEED_ENABLED = 'features.views.homefeed.enabled';

export enum TopBarMenuItemKeys {
    CATALOG = 'web_catalog',
    TOPNEWS = 'web_topnews',
    ASKVIEW = 'askview',
    EXIT_PUBLICATION = 'web_exit_publication',

    // Voyager
    VOYAGER_HOME = 'voyager_home',
    VOYAGER_BOOKS = 'voyager_books',
    VOYAGER_MAGAZINES = 'voyager_magazines',
    VOYAGER_NEWSPAPERS = 'voyager_newspapers',
}
